var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BreadCrumb"},[_c('ul',_vm._l((_vm.breadCrumbs),function(data){return _c('li',{key:data.name},[(data.to)?[_c('nuxt-link',{attrs:{"to":data.to}},[_vm._v(_vm._s(data.name))])]:[_vm._v(_vm._s(data.name))]],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }